import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { camelizeKeys } from "lib/helpers";

function* getEnterpriseProjectLookupOptions(action) {
  const { search } = action.payload;
  const { success, data, error } = yield* makeRequest.get(`/enterprise/projects_search?search=${search}`);

  if (success && data) {
    yield put(actions.setEnterpriseProjectLookupOptions(camelizeKeys(data.body.results)));
  } else if (error) {
    return getErrorActions({
      error,
    });
  }

  return null;
}

export default getEnterpriseProjectLookupOptions;
